// TODO: duplicated because those should not be bundled in web worker. We can avoid this by transforming utils into a library of modules.
interface ImportMeta {
  env: Record<string, string> | undefined;
}

export const envSatelliteId = (): string | undefined => {
  const viteEnvSatelliteId = (): string | undefined =>
    typeof import.meta !== 'undefined' &&
    typeof (import.meta as unknown as ImportMeta).env !== 'undefined'
      ? ((import.meta as unknown as ImportMeta).env?.VITE_SATELLITE_ID ??
        (import.meta as unknown as ImportMeta).env?.PUBLIC_SATELLITE_ID)
      : undefined;

  return typeof process !== 'undefined' && typeof process.env !== 'undefined'
    ? (process.env.NEXT_PUBLIC_SATELLITE_ID ?? viteEnvSatelliteId())
    : viteEnvSatelliteId();
};

export const envContainer = (): string | undefined => {
  const viteEnvContainer = (): string | undefined =>
    typeof import.meta !== 'undefined' &&
    typeof (import.meta as unknown as ImportMeta).env !== 'undefined'
      ? ((import.meta as unknown as ImportMeta).env?.VITE_CONTAINER ??
        (import.meta as unknown as ImportMeta).env?.PUBLIC_CONTAINER)
      : undefined;

  return typeof process !== 'undefined' && typeof process.env !== 'undefined'
    ? (process.env.NEXT_PUBLIC_CONTAINER ?? viteEnvContainer())
    : viteEnvContainer();
};

export const envGoogleClientId = (): string | undefined => {
  const viteEnvGoogleClientId = (): string | undefined =>
    typeof import.meta !== 'undefined' &&
    typeof (import.meta as unknown as ImportMeta).env !== 'undefined'
      ? ((import.meta as unknown as ImportMeta).env?.VITE_GOOGLE_CLIENT_ID ??
        (import.meta as unknown as ImportMeta).env?.PUBLIC_GOOGLE_CLIENT_ID)
      : undefined;

  return typeof process !== 'undefined' && typeof process.env !== 'undefined'
    ? (process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID ?? viteEnvGoogleClientId())
    : viteEnvGoogleClientId();
};

export const envGitHubClientId = (): string | undefined => {
  const viteEnvGitHubClientId = (): string | undefined =>
    typeof import.meta !== 'undefined' &&
    typeof (import.meta as unknown as ImportMeta).env !== 'undefined'
      ? ((import.meta as unknown as ImportMeta).env?.VITE_GITHUB_CLIENT_ID ??
        (import.meta as unknown as ImportMeta).env?.PUBLIC_GITHUB_CLIENT_ID)
      : undefined;

  return typeof process !== 'undefined' && typeof process.env !== 'undefined'
    ? (process.env.NEXT_PUBLIC_GITHUB_CLIENT_ID ?? viteEnvGitHubClientId())
    : viteEnvGitHubClientId();
};

export const envApiUrl = (): string | undefined => {
  const viteEnvApiUrl = (): string | undefined =>
    typeof import.meta !== 'undefined' &&
    typeof (import.meta as unknown as ImportMeta).env !== 'undefined'
      ? ((import.meta as unknown as ImportMeta).env?.VITE_JUNO_API_URL ??
        (import.meta as unknown as ImportMeta).env?.PUBLIC_JUNO_API_URL)
      : undefined;

  return typeof process !== 'undefined' && typeof process.env !== 'undefined'
    ? (process.env.NEXT_PUBLIC_JUNO_API_URL ?? viteEnvApiUrl())
    : viteEnvApiUrl();
};
